export const getOptions = () => ({
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
        legend: {
            position: 'left'
        }
    }
});
